import NextLink from "next/link";
import type { LinkProps as NextLinkProps } from "next/link";
import MuiLink from "@mui/material/Link";
import type { LinkProps as MuiLinkProps } from "@mui/material/Link";
import type { MouseEventHandler } from "react";
import { forwardRef } from "react";
import type { SystemStyleObject, Theme } from "@mui/system";

const LinkBehaviour = forwardRef<HTMLAnchorElement, NextLinkProps>((props, ref) => (
  <NextLink ref={ref} {...props} />
));
LinkBehaviour.displayName = "LinkBehaviour";

export interface LinkProps extends Omit<MuiLinkProps, "href" | "onClick"> {
  href: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  locale?: string;
}

export function Link({
  children,
  href,
  variant = "body2",
  color = "inherit",
  underline = "none",
  sx = {},
  onClick,
  locale,
}: LinkProps) {
  const handleOnClick: MouseEventHandler<HTMLAnchorElement> = (event) => {
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <MuiLink
      href={href}
      locale={locale}
      component={LinkBehaviour}
      sx={{ ...(sx as SystemStyleObject<Theme>), cursor: "pointer" }}
      variant={variant}
      color={color}
      underline={underline}
      onClick={handleOnClick}
    >
      {children}
    </MuiLink>
  );
}
